import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

const LoadingSpinner = () => {
  return (
    <div className='inset-0 absolute flex items-center justify-center bg-muted opacity-50 z-12'>
      <FontAwesomeIcon icon={['fal', 'circle-notch']} spin size='3x' className='text-muted-foreground' />
    </div>
  )
}

export default LoadingSpinner